module.exports = __webpack_public_path__ + "img/icon_target.31059002.svg";